import { useLingui } from "@lingui/react/macro";
import { useState } from "react";
import { ActionCardButton } from "@/components/ActionCard/ActionCard";
import { DialogPanel } from "@medoma/components/DialogPanel/DialogPanel";
import AddPersonIcon from "@medoma/components/icons/AddPersonIcon";
import type { IActivityRequirement } from "@medoma/models/activityRequirements";
import type { SiteId } from "@medoma/models/sites";
import { AssignShiftPicker } from "./AssignShiftPicker";

export type AssignShiftTarget =
  | { kind: "occurrence"; activityId: string; occurrenceId: string }
  | { kind: "group"; groupId: string };

export const AssignShiftAction = ({
  target,
  assignedShiftIds,
  shiftsFromDate,
  unfulfilledRequirements,
  patientSiteId,
}: {
  target: AssignShiftTarget;
  assignedShiftIds: number[];
  shiftsFromDate: Date;
  unfulfilledRequirements: IActivityRequirement[];
  patientSiteId: SiteId;
}) => {
  const { t } = useLingui();
  const [isOpen, setIsOpen] = useState(false);
  const close = () => setIsOpen(false);

  return (
    <>
      <ActionCardButton
        icon={<AddPersonIcon />}
        title={t`Tilldela`}
        onClick={() => setIsOpen(true)}
      />
      <DialogPanel
        isOpen={isOpen}
        onClose={close}
        title={t`Tilldela`}
        hideTitle
        position="bottom"
      >
        <AssignShiftPicker
          target={target}
          assignedShiftIds={assignedShiftIds}
          shiftsFromDate={shiftsFromDate}
          unfulfilledRequirements={unfulfilledRequirements}
          patientSiteId={patientSiteId}
          onSuccess={close}
        />
      </DialogPanel>
    </>
  );
};
